(() => {
  if (customElements.get('hero-slider')) return;

  class HeroSlider extends customElements.get('slider-component') {
    constructor() {
      super();
    }

    connectedCallback() {
      // Options
      this.options = {
        ...this.options,
        breakpoints: {
          990: { speed: 1000 }
        }
      };

      // Enable autoplay globally (required by Swiper)
      if (this.dataset.autoplay === 'true') {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed || 5000
        };
      }

      // Initialize slider
      this.initSlider();

      // Custom: per-slide delay
      this.enablePerSlideAutoplay();

      // Toggle handlers
      this.toggleHandlers();
    }

    /**
     * Enables per-slide autoplay delay reading
     * from data-slide-duration attribute.
     */
    enablePerSlideAutoplay() {
      if (!this.slider) return;

      const swiper = this.slider;

      const updateDelay = () => {
        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;

        const duration = activeSlide.getAttribute('data-slide-duration');

        if (duration) {
          const ms = parseInt(duration) * 1000;

          // Update autoplay delay dynamically
          swiper.params.autoplay.delay = ms;

          // Restart autoplay to apply new delay
          if (swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.stop();
            swiper.autoplay.start();
          }
        }
      };

      // When slider initializes
      swiper.on('init', () => updateDelay());

      // When slide changes
      swiper.on('slideChange', () => updateDelay());
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
